import { render, staticRenderFns } from "./Consignment.vue?vue&type=template&id=d3f9cabc&scoped=true&"
import script from "./Consignment.vue?vue&type=script&lang=js&"
export * from "./Consignment.vue?vue&type=script&lang=js&"
import style0 from "./Consignment.vue?vue&type=style&index=0&id=d3f9cabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f9cabc",
  null
  
)

component.options.__file = "Consignment.vue"
export default component.exports